<template>  
  <v-list dense>
    <v-row no-gutters>
      <v-col
        cols="6"
        v-for="(item, j) in subCatFormato(formatosItem)"
        :key="`${j}-${item.Formato}`"
      >
        <v-list-item>
          <v-list-item-content>
            <v-checkbox
              v-model="selectedFilterFormato"
              :value="item.Formato"
              @click="setFormat(selectedFilterFormato)"
              color="#B05954"
              class="my-n2"
              hide-details
              :ripple="false"
              :disabled="
                filterconsolidado.length === 0 ||
                subCatFormato(formatosItem).length === 1
              "
              dense
            >
              <template v-slot:label>
                <div class="body-2">
                  {{ item.Formato }}
                </div>
              </template>
            </v-checkbox>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
  </v-list>
</template>

<script>
  import { mapState, mapGetters, mapMutations } from "vuex";

  export default {
    data() {
      return {
        checkFormato: [],
      };
    },
    props: {
      formatosItem: Array
    },
    methods: {
      ...mapMutations(["GET_BUSCARFORMATO", "CLR_BUSCARFORMATO", "clr_page"]),
      clrFormat() {
        this.checkFormato = [];
        this.CLR_BUSCARFORMATO();
      },
      setFormat(valor) {
        this.clr_page()
        this.GET_BUSCARFORMATO(valor);
      },
    },
    computed: {
      ...mapGetters(["filtermarca", "filterconsolidado"]),
      ...mapState([
        "ttArticuloAll",
        "marcaidsel",
        "changeSubcat",
        "filter",
        "ttMarcas",
        "SubCategorias",
      ]),
      selectedFilterFormato: {
        get() {
          return this.filter.formato;
        },
        set(valor) {
          this.GET_BUSCARFORMATO(valor);
        },
      },
      subCatFormato: function () {
        return function (items) {
          const uniqueFormat = Array.from(
            new Set(items.map((item) => item.Formato))
          ).map((Formato) => {
            return items.find((id) => id.Formato === Formato);
          });

          return uniqueFormat;
        };
      },
    },
  };
</script>

<style></style>
